
import { ref } from "vue";
import { useRouter } from "vue-router";
import question from "@/views/QuestionView.vue";
import question2 from "@/views/QuestionTwoView.vue";
import correct from "@/views/CorrectView.vue";
import reason from "@/views/ReasonView.vue";
import toNav from "@/components/ToNav.vue";
import jiexiao from "@/views/JieXiaoView.vue";
import { showDialog } from "vant";

export default {
  components: { question, question2, correct, reason, toNav, jiexiao },
  data() {
    return {
      show: false,
      postaimqus: 0,
      title: "传递的是一个值",
      flag: "question",
      correct: "0",
      chatiShow: true,
    };
  },
  setup() {
    //router是全局路由对象，route= userRoute()是当前路由对象
    let router = useRouter();
    const checked = ref("");
    let name = "张三";
    let age = "18";

    return { checked, age };
  },
  methods: {
    showPopup() {
      this.chatiShow = false;
      this.show = true;
      this.postaimqus = 1;
      console.log(this.show + "test it11!");
    },
    updateCorrect(param) {
      console.log("shiwo");
      this.flag = "question2";
      this.postaimqus = 3;
      console.log("赋值reason");
    },
    reasonCorrect(param) {
      console.log("reasonCorrect");
      this.flag = "question";
      this.postaimqus = 1;
    },
    jiexiaoChanged(param) {
      // console.log("JieXiaoChanged");
      this.flag = "question";
      this.postaimqus = 2;
    },
    chatiChanged(param) {
      // console.log("JieXiaoChanged");
      if (this.chatiShow) {
        this.chatiShow = false;
      } else {
        this.chatiShow = true;
      }
    },
    testClose() {
      console.log("testClosetestClosetestClosetestClose");
    },
    updateChanged(param) {
      console.log(param[0]); //获取param1的值
      console.log(param[1]); //获取param2的值
      this.aimQus = param[0];
      this.radioVal = param[1];
      switch (this.postaimqus) {
        case (this.postaimqus = 0):
          //这里是值对应的处理
          if (this.radioVal == 0) {
            // this.$refs.elDialog.stylevan-popup;
            showDialog({
              title: "提示",
              message: "您还没有做出选择哟。",
            }).then(() => {
              // on close
            });
          } else {
            if (this.radioVal == 5) {
              this.flag = "correct";
              this.correct = 1;
              console.log("第一道题答对了，显示正确内容继续");
            } else {
              console.log("第一道题答错了，显示正确内容继续");
              this.flag = "correct";
              this.correct = "0";
            }
          }

          break;
        case (this.postaimqus = 1):
          //这里是值对应的处理
          // if (this.radioVal == 4) {
          //   this.postaimqus = 2;
          //   console.log("第二道题答对了，显示正确内容继续");
          // } else {
          //   console.log("第二道题答错了，显示正确内容继续");
          // }
          this.flag = "jiexiao";
          console.log("jiexiaojiexiaojiexiao");
          break;
        case (this.postaimqus = 2):
          //这里是值对应的处理
          if (this.radioVal == 5) {
            this.flag = "correct";
            this.correct = 1;
            // this.postaimqus = 3;
            console.log("第三道题答对了，显示正确内容继续");
          } else {
            console.log("第三道题答错了，显示正确内容继续");
            this.flag = "correct";
            this.correct = "0";
            // this.postaimqus = 3;
          }
          break;
        case (this.postaimqus = 3):
          //这里是值对应的处理
          if (this.radioVal == 1) {
            // this.postaimqus = 4;
            this.flag = "correct";
            this.correct = "1";
            console.log("第四道题答对了，显示正确内容继续");
          } else {
            this.flag = "correct";
            this.correct = "0";
            console.log("第四道题答错了，显示正确内容继续");
          }
          break;
        case (this.postaimqus = 4):
          //这里是值对应的处理
          if (this.radioVal == 3) {
            console.log("第五道题答对了，显示正确内容继续");
          } else {
            console.log("第五道题答错了，显示正确内容继续");
          }
          break;

        default:
          //这里是没有找到对应的值处理
          break;
      }
    },
  },
};
